// extracted by mini-css-extract-plugin
export default {"edit":"Passengers_edit__PQlAO","cancel":"Passengers_cancel__-YeKB"};